import {memo} from 'react';
import {Avatar} from "@material-tailwind/react";
import {size} from "@material-tailwind/react/types/components/avatar";

interface ProviderAvatarProps {
    image: string,
    size?: size
    className?: string,
    imageSize?: string
}

const BrokerAvatar = ({image, className, imageSize = "w-16 h-8", size = "md"}: ProviderAvatarProps) => {
    return <Avatar size={size} variant="rounded"
                   className={`border border-blue-gray-50 dark:border-blue-gray-500 bg-white object-contain p-1 mr-2 ${className ?? ''} ${imageSize ?? 'w-16 h-8'}`}
                   src={image}/>;
}

export default memo(BrokerAvatar);
